// extracted by mini-css-extract-plugin
export var base = "_21-0";
export var updateBanner = "_21-1";